import { render, staticRenderFns } from "./message-popup.vue?vue&type=template&id=6c2c203d&scoped=true&"
import script from "./message-popup.vue?vue&type=script&lang=js&"
export * from "./message-popup.vue?vue&type=script&lang=js&"
import style0 from "./message-popup.vue?vue&type=style&index=0&id=6c2c203d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2c203d",
  null
  
)

export default component.exports